import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {HeartIcon} from '../shared/icons'
import {cheer} from '../../data/EventResultsStreams';
import {Loading} from './Loading';
import {isLoggedIn} from '../../utils/isLoggedIn';
import {LogInOrSignUp} from '../modal/LogInOrSignUp';
import { trackGoogleEvent } from '../../utils/googleEvents';
import {colors} from '../../shared/styles';
import { styles } from './styles';

export class CheerComponent extends Component {

  static propTypes = {
    canCheer: PropTypes.bool.isRequired,
    racerId: PropTypes.number.isRequired,
    eventId: PropTypes.number.isRequired,
    courseId: PropTypes.number.isRequired,
    resultEntryId: PropTypes.number,
    afterCheer: PropTypes.func.isRequired,
    cheerCount: PropTypes.number,
    type: PropTypes.string,
    t: PropTypes.func
  };

  state = {
    sendingCheer: false,
    cheer: this.props.canCheer,
    hover: false,
  };

  // TODO: Are this many setState()s needed here?...
  sendCheer = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    trackGoogleEvent('Social', 'Click', 'Like');
    const {afterCheer} = this.props;
    if (!this.state.cheer || !isLoggedIn()) return null;
    else this.setState(
      {sendingCheer: true, cheer: !this.state.cheer},
      async () => {
        const cheerStream = await cheer(this.props);
        return cheerStream.subscribe(
          afterCheer,
          () => this.setState({cheer: !this.state.cheer}),
          () => this.setState({sendingCheer: false})
        )
      }
    )
  };


  render() {
    const {sendingCheer, cheer, hover} = this.state;
    const {
      cheerCount,
      type,
      isMobile,
      t
    } = this.props;

    const iconColor = ((cheer && cheerCount > 0)
      || (!cheer && cheerCount > 0 && type !== 'overview')
      || type==='eventResults' ) ? colors.blue : colors.grey;

    if (sendingCheer) {
      return (<div style={styles.cheerLoading}>
        <Loading timeoutMessage={t('Still thinking...')}/>
      </div>);
    } else {
      return (
        <div
          style={styles.cheerContainer}
          onMouseEnter={() => { this.setState({hover: true})} }
          onMouseLeave={() => { this.setState({hover: false})} }
        >
          { isLoggedIn() &&
              <HeartIcon
                onClick={this.sendCheer}
                height={18}
                fill={iconColor}
                isFilled={!cheer || hover}
              />
            //this part of code should be removed after endpoint update for event result ==> || type=="eventResults"
          }

          { !isLoggedIn() &&
            <LogInOrSignUp
              control='cheerResult'
              isLoggedIn={isLoggedIn()}
              isMobile={isMobile}
              cheerCount={cheerCount}
            />
          }
          {(cheerCount > 0) &&
            <span style={styles.cheerNumber(cheer)}>
              {cheerCount}
            </span>
          }
        </div>
      );
    }
  }

}

export const Cheer = withTranslation()(CheerComponent);



/** WEBPACK FOOTER **
 ** ./components/shared/Cheer.js
 **/